"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const max_1 = __importDefault(require("libphonenumber-js/max"));
const react_1 = __importDefault(require("react"));
const Label_1 = __importDefault(require("../Label"));
const ErrorHelper_1 = __importDefault(require("./ErrorHelper"));
const List_1 = __importDefault(require("./List"));
const StyledInput_1 = __importDefault(require("./StyledInput"));
const StyledInputWrapper_1 = __importDefault(require("./StyledInputWrapper"));
const StyledListWrapper_1 = __importDefault(require("./StyledListWrapper"));
const StyledSelect_1 = __importDefault(require("./StyledSelect"));
const Value_1 = __importDefault(require("./Value"));
const InputPhone = ({ country, defaultIsOpen, errorMessage, id, isValid, label, phone, placeholder, required, onChangeValues, disabled = false, variant: baseVariant, name, flagsHost, ...rest }) => {
    const variant = react_1.default.useMemo(() => {
        if (baseVariant) {
            return baseVariant;
        }
        if (isValid === false) {
            return 'error';
        }
        return undefined;
    }, [isValid, baseVariant]);
    const handleOnChange = react_1.default.useCallback((country, phone) => {
        if (!onChangeValues) {
            return;
        }
        const onlyNumbers = phone.replace(/\D/g, '');
        const phoneNumber = (0, max_1.default)(onlyNumbers, country.alphaCode2);
        let formattedPhone = onlyNumbers;
        let nonFormattedPhone = onlyNumbers;
        let isValidPhone = false;
        if (phoneNumber) {
            formattedPhone = phoneNumber.formatNational();
            nonFormattedPhone = phoneNumber.number;
            isValidPhone = phoneNumber.isValid();
        }
        onChangeValues({
            country,
            isValid: isValidPhone,
            phone: nonFormattedPhone,
            formattedPhone
        });
    }, [onChangeValues]);
    const handleOnChangeCountry = react_1.default.useCallback((country) => {
        handleOnChange(country, phone);
    }, [phone, handleOnChange]);
    const handleOnChangePhone = react_1.default.useCallback((e) => {
        handleOnChange(country, e.target.value);
    }, [country, handleOnChange]);
    return ((0, jsx_runtime_1.jsxs)("div", { ...rest, children: [label && (0, jsx_runtime_1.jsx)(Label_1.default, { htmlFor: id, children: label }), (0, jsx_runtime_1.jsxs)(StyledInputWrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(StyledSelect_1.default, { value: country, defaultIsOpen: defaultIsOpen, renderValue: (country) => ((0, jsx_runtime_1.jsx)(Value_1.default, { ...country, flagsHost: flagsHost })), disabled: disabled, children: (0, jsx_runtime_1.jsx)(StyledListWrapper_1.default, { children: (0, jsx_runtime_1.jsx)(List_1.default, { flagsHost: flagsHost, onChangeCountry: handleOnChangeCountry, value: country }) }) }), (0, jsx_runtime_1.jsx)(StyledInput_1.default, { onChange: handleOnChangePhone, type: 'tel', placeholder: placeholder, value: phone, variant: variant, required: required, disabled: disabled, id: id, name: name })] }), isValid === false && (0, jsx_runtime_1.jsx)(ErrorHelper_1.default, { children: errorMessage })] }));
};
exports.default = InputPhone;
//# sourceMappingURL=InputPhone.js.map